import React from "react";
import { Divider, Button, Descriptions } from "antd";
import { $t, i18n } from "~/i18n.js";
import { DateFormat } from "~/components/date/DateFormat.jsx";
import { ExtrasDescription } from "~/components/form/extras.jsx";

export default function StepBevestig({ editMode, product, checkoutItem, onPrev, onPay }) {
  
  console.log("StepBevestig", { product, checkoutItem });
  
  if (!product) return null;

  const symbol = i18n.currencySymbol;

  return (
    <section>
      <div>
        <div className="title label" style={{ marginBottom: 24 }}>
          {$t("Bevestig")}
        </div>

        <Descriptions column={1} size="small" bordered={false}>
          <Descriptions.Item label={$t("Naam")}>
            {checkoutItem.name}
          </Descriptions.Item>
          <Descriptions.Item label={$t("Email")}>
            {checkoutItem.email}
          </Descriptions.Item>
          <Descriptions.Item label={$t("Telefoonnummer")}>
            {checkoutItem.phone}
          </Descriptions.Item>
          {product.has_calendar && checkoutItem.date && (
            <Descriptions.Item label={$t("Datum")}>
              <DateFormat date={checkoutItem.date} />
            </Descriptions.Item>
          )}
          {product.has_calendar && checkoutItem.timeslot && (
            <Descriptions.Item label={$t("Tijdslot")}>
              {checkoutItem.timeslot}
            </Descriptions.Item>
          )}
          
          <Descriptions.Item label={$t("Opmerking")}>
            {checkoutItem.remark}
          </Descriptions.Item>
        </Descriptions>


        <ExtrasDescription
          extraData={checkoutItem.extra}
          extras={product.extras}
        />
        
        <Divider style={{ margin: "24px 0" }} />

        {/* Price summary as before */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: 14,
            marginBottom: 3,
          }}
        >
          <span>{product.name}</span>
          <span>
            {symbol}
            {product.base_price}
          </span>
        </div>

        {checkoutItem.addons
          .filter((a) => a.quantity > 0)
          .map((a) => (
            <div
              key={a.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: 14,
              }}
            >
              <span>
                {a.description} ({a.quantity}x)
              </span>
              <span>
                {symbol}
                {a.price.toFixed(2)}{" "}
              </span>
            </div>
          ))}
      </div>

      <Divider style={{ margin: "12px 0" }} />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <b>{$t("Totaal")}</b>
        <span>
          {symbol} {checkoutItem.total_price.toFixed(2)}
        </span>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 24,
        }}
      >
        <Button onClick={onPrev}>{$t("Terug")}</Button>
        <Button type="primary" onClick={onPay}>
          {editMode ? $t('Opslaan') : $t("Naar betalen")}
        </Button>
      </div>
    </section>
  );
}
